import { DateTime } from 'luxon';
import { Fieldset, Input } from '@flixbus/honeycomb-react';
import { toISODate } from '../../../../helpers/dateTime';

import { useVoucherFormContext } from '../../Context';

import { BlackoutPeriodRule } from '../../../../types/Rules';

const BlackoutFrom = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const ruleValue = rules.filter(r => r.type === 'blackout_period')[0] as
    | BlackoutPeriodRule
    | undefined;

  const dateObject = ruleValue?.start ? DateTime.fromISO(ruleValue.start) : null;

  return (
    <Fieldset itemSpacing='half'>
      <Input
        name='rule-blackout-from-input'
        id='rule-blackout-from-input'
        label={<>From</>}
        type='date'
        min={new Date().toString()}
        required
        value={dateObject ? dateObject.setLocale('de').toFormat('yyyy-MM-dd') : ''}
        onChange={e => {
          const { value } = e.target;

          if (value === '') {
            // Remove the date
            handleRuleChange(
              {
                type: 'blackout_period',
                ...ruleValue,
                start: '',
              },
              true,
            );
          } else {
            const date = new Date(value);
            handleRuleChange({
              type: 'blackout_period',
              ...ruleValue,
              start: toISODate(DateTime.fromJSDate(date)),
            });
          }
        }}
      />
    </Fieldset>
  );
};

export default BlackoutFrom;
